import { BaseRestDataProvider } from './BaseRestDataProvider';
import { TimeWritingEntry } from '../models/TimeWritingEntry';

export class TimeWritingRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/timewriting');
  }

  getByUserAndDateRange(userId: string, from: string, to: string): Promise<TimeWritingEntry[]> {
    return this.get<TimeWritingEntry[]>(`?userId=${userId}&from=${from}&to=${to}`);
  }

  getByProject(projectId: string): Promise<TimeWritingEntry[]> {
    return this.get<TimeWritingEntry[]>(`/project/${projectId}`);
  }

  getById(id: string): Promise<TimeWritingEntry> {
    return this.get<TimeWritingEntry>(`/${id}`);
  }

  create(entry: TimeWritingEntry): Promise<TimeWritingEntry> {
    return this.post<TimeWritingEntry>(``, entry);
  }

  update(id: string, entry: TimeWritingEntry): Promise<void> {
    return this.put<void>(`/${id}`, entry);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
